import { render } from "./header-btn.vue?vue&type=template&id=d50ec878"
import script from "./header-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./header-btn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/products/pages/products-list/components/header-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d50ec878"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d50ec878', __exports__)) {
    console.log('reload')
    api.reload('d50ec878', __exports__)
  }
  
  module.hot.accept("./header-btn.vue?vue&type=template&id=d50ec878", () => {
    console.log('re-render')
    api.rerender('d50ec878', render)
  })

}


export default __exports__